type ErrorMessageProps = {
  children: React.ReactNode;
  className?: string;
};

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ children, className = '' }) => {
  if (!children) return null;
  return <div className={`text-red-600 ${className}`}>{children}</div>;
};
